import { PatchDossierDetails } from "@/entities/dossier-details";
import { FormState } from "react-hook-form";
import { z } from "zod";
import { applyReikwijdteRefine, dossierDetailsBaseFields } from "./dossier-details-schema";

export const updateDetailsSchema = z
    .object({
        ...dossierDetailsBaseFields,
        updateSections: z.boolean(),
    })
    .superRefine(applyReikwijdteRefine);

export type UpdateDossierDetailsData = z.infer<typeof updateDetailsSchema>;

type UpdateDossierDetailsPayload = Partial<UpdateDossierDetailsData> & { updateSections: boolean };

export function getActieAndPayload(
    dirtyFields: FormState<UpdateDossierDetailsData>["dirtyFields"],
    data: UpdateDossierDetailsData,
    previousReikwijdte: "Stations" | "Trajecten" | "Landelijk"
): { actie: PatchDossierDetails["actie"]; payload: UpdateDossierDetailsPayload } {
    let actie: PatchDossierDetails["actie"] = "Legacy";
    const payload: UpdateDossierDetailsPayload = { updateSections: data.updateSections };

    if (dirtyFields.omschrijving) {
        payload.omschrijving = data.omschrijving;
        actie = "OmschrijvingenUpdate";
    }

    if (dirtyFields.omschrijvingExtraContext) {
        payload.omschrijvingExtraContext = data.omschrijvingExtraContext;
        actie = "OmschrijvingenUpdate";
    }

    if (data.reikwijdte !== previousReikwijdte || dirtyFields.stations || dirtyFields.trajecten) {
        // if omschrijving was updated too, set actie to "Alles"
        actie = actie === "OmschrijvingenUpdate" ? "Alles" : "ReikwijdteUpdate";
        payload.reikwijdte = data.reikwijdte;
        if (data.reikwijdte === "Stations") payload.stations = data.stations;
        if (data.reikwijdte === "Trajecten") payload.trajecten = data.trajecten;
    }
    return { actie, payload };
}
